import React from 'react';
import { GuestData, LoginData } from '../CoveyTypes';

const Context = React.createContext<LoginData | GuestData>({nickname: "", loggedIn: false});

export default Context;
